// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import LevelButton from "../prefabs/LevelButton";
import BtnPlayLevel from "../prefabs/BtnPlayLevel";
import UIButton from "../core/components/UIButton";
import BtnBack from "../core/prefabs/BtnBack";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnAudio from "../core/prefabs/BtnAudio";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { SceneData, TransitionPoint } from '../app-routing';
import { GameDataHandler } from '../game/GameDataHandler';
import { LevelNameValues } from './../game/level/levels/level';
import { Sounds } from '../sounds';
/* END-USER-IMPORTS */

export default class LevelSelect extends BaseScene {

  constructor() {
    super("LevelSelect");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // rectangle_1
    const rectangle_1 = this.add.rectangle(960, 387, 128, 128);
    rectangle_1.scaleX = 8.483107003704424;
    rectangle_1.scaleY = 5.7470534585448885;
    rectangle_1.isFilled = true;
    rectangle_1.fillColor = 54;

    // MapHolder
    const mapHolder = this.add.container(960, 469);

    // grid
    const grid = this.add.image(0, 18, "level-select", "holo-city-grid.png");
    mapHolder.add(grid);

    // buildingHolder
    const buildingHolder = this.add.container(0, 16);
    mapHolder.add(buildingHolder);

    // holo_building_large_png
    const holo_building_large_png = this.add.image(15, -51, "level-select", "holo-building-medium.png");
    holo_building_large_png.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_large_png);

    // holo_building_medium_png
    const holo_building_medium_png = this.add.image(-153, -55, "level-select", "holo-building-medium.png");
    holo_building_medium_png.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_medium_png);

    // holo_building_small_png
    const holo_building_small_png = this.add.image(-107, -43, "level-select", "holo-building-small.png");
    holo_building_small_png.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_small_png);

    // holo_building_medium_png_1
    const holo_building_medium_png_1 = this.add.image(151, -55, "level-select", "holo-building-medium.png");
    holo_building_medium_png_1.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_medium_png_1);

    // holo_building_medium_png_2
    const holo_building_medium_png_2 = this.add.image(-42, -17, "level-select", "holo-building-medium.png");
    holo_building_medium_png_2.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_medium_png_2);

    // holo_building_medium_png_3
    const holo_building_medium_png_3 = this.add.image(81, 18, "level-select", "holo-building-medium.png");
    holo_building_medium_png_3.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_medium_png_3);

    // holo_building_medium_png_4
    const holo_building_medium_png_4 = this.add.image(222, 6, "level-select", "holo-building-medium.png");
    holo_building_medium_png_4.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_medium_png_4);

    // holo_building_medium_png_5
    const holo_building_medium_png_5 = this.add.image(-248, 3, "level-select", "holo-building-large.png");
    holo_building_medium_png_5.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_medium_png_5);

    // holo_building_medium_png_6
    const holo_building_medium_png_6 = this.add.image(161, 54, "level-select", "holo-building-medium.png");
    holo_building_medium_png_6.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_medium_png_6);

    // holo_building_small_png_1
    const holo_building_small_png_1 = this.add.image(-145, 11, "level-select", "holo-building-small.png");
    holo_building_small_png_1.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_small_png_1);

    // holo_building_small_png_2
    const holo_building_small_png_2 = this.add.image(-199, 23, "level-select", "holo-building-small.png");
    holo_building_small_png_2.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_small_png_2);

    // holo_building_small_png_3
    const holo_building_small_png_3 = this.add.image(-98, 28, "level-select", "holo-building-small.png");
    holo_building_small_png_3.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_small_png_3);

    // holo_building_small_png_4
    const holo_building_small_png_4 = this.add.image(-152, 48, "level-select", "holo-building-small.png");
    holo_building_small_png_4.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_small_png_4);

    // holo_building_small_png_5
    const holo_building_small_png_5 = this.add.image(-46, 45, "level-select", "holo-building-small.png");
    holo_building_small_png_5.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_small_png_5);

    // holo_building_small_png_6
    const holo_building_small_png_6 = this.add.image(-103, 63, "level-select", "holo-building-small.png");
    holo_building_small_png_6.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_small_png_6);

    // holo_building_medium_png_7
    const holo_building_medium_png_7 = this.add.image(34, 101, "level-select", "holo-building-medium.png");
    holo_building_medium_png_7.setOrigin(0.5, 1);
    buildingHolder.add(holo_building_medium_png_7);

    // buttonUI
    const buttonUI = this.add.container(0, 0);
    mapHolder.add(buttonUI);

    // dotHolder
    const dotHolder = this.add.container(0, 17);
    buttonUI.add(dotHolder);

    // dot1
    const dot1 = this.add.image(-250, 5, "level-select", "circle.png");
    dotHolder.add(dot1);

    // dot2
    const dot2 = this.add.image(-173, -49, "level-select", "circle.png");
    dotHolder.add(dot2);

    // dot3
    const dot3 = this.add.image(-63, 52, "level-select", "circle.png");
    dotHolder.add(dot3);

    // dot4
    const dot4 = this.add.image(95, -138, "level-select", "circle.png");
    dotHolder.add(dot4);

    // dot5
    const dot5 = this.add.image(236, 18, "level-select", "circle.png");
    dotHolder.add(dot5);

    // buttons
    const buttons = this.add.container(0, 0);
    buttonUI.add(buttons);

    // button1
    const button1 = new LevelButton(this, -351, -289);
    button1.scaleX = 1.2;
    button1.scaleY = 1.2;
    buttons.add(button1);

    // button2
    const button2 = new LevelButton(this, -176, -289);
    button2.scaleX = 1.2;
    button2.scaleY = 1.2;
    buttons.add(button2);

    // button3
    const button3 = new LevelButton(this, 0, -289);
    button3.scaleX = 1.2;
    button3.scaleY = 1.2;
    buttons.add(button3);

    // button4
    const button4 = new LevelButton(this, 175, -289);
    button4.scaleX = 1.2;
    button4.scaleY = 1.2;
    buttons.add(button4);

    // button5
    const button5 = new LevelButton(this, 350, -289);
    button5.scaleX = 1.2;
    button5.scaleY = 1.2;
    buttons.add(button5);

    // heroDisk
    const heroDisk = this.add.image(960, 619, "level-select", "hero-disc.png");
    heroDisk.alpha = 0;
    heroDisk.alphaTopLeft = 0;
    heroDisk.alphaTopRight = 0;
    heroDisk.alphaBottomLeft = 0;
    heroDisk.alphaBottomRight = 0;

    // batwheelImage
    const batwheelImage = this.add.image(960, 619, "level-select", "icon-hero-bam.png");
    batwheelImage.alpha = 0;
    batwheelImage.alphaTopLeft = 0;
    batwheelImage.alphaTopRight = 0;
    batwheelImage.alphaBottomLeft = 0;
    batwheelImage.alphaBottomRight = 0;

    // PlayBox
    const playBox = this.add.container(960, 620);

    // box_bg
    const box_bg = this.add.image(0, 0, "level-select", "box-hero.png");
    box_bg.visible = false;
    playBox.add(box_bg);

    // btnPlayLevel
    const btnPlayLevel = new BtnPlayLevel(this, 0, -2);
    btnPlayLevel.scaleX = 1;
    btnPlayLevel.scaleY = 1;
    playBox.add(btnPlayLevel);

    // bcHolder
    const bcHolder = this.add.container(960, 384);

    // bcBg
    const bcBg = this.add.rectangle(0, -1, 128, 128);
    bcBg.scaleX = 7.787782623849635;
    bcBg.scaleY = 5.570290621459875;
    bcBg.isFilled = true;
    bcBg.fillColor = 26563;
    bcHolder.add(bcBg);

    // bg
    this.add.image(960, 384, "level-select", "bg-levelselect.png");

    // character
    const character = this.add.image(450, 950, "level-select", "popup-bam.png");

    // btnBack
    const btnBack = new BtnBack(this, 84, 84);
    this.add.existing(btnBack);

    // btnAudio
    const btnAudio = new BtnAudio(this, 1836, 84);
    this.add.existing(btnAudio);

    // lists
    const levelButtons = [button1, button2, button3, button4, button5];
    const buildings = [holo_building_medium_png_7, holo_building_small_png_6, holo_building_small_png_5, holo_building_small_png_4, holo_building_small_png_3, holo_building_small_png_2, holo_building_small_png_1, holo_building_medium_png_6, holo_building_medium_png_5, holo_building_medium_png_4, holo_building_medium_png_3, holo_building_medium_png_2, holo_building_medium_png_1, holo_building_small_png, holo_building_medium_png, holo_building_large_png];
    const dots = [dot1, dot2, dot3, dot4, dot5];

    // button2 (prefab fields)
    button2.levelNum = 1;

    // button3 (prefab fields)
    button3.levelNum = 2;

    // button4 (prefab fields)
    button4.levelNum = 3;

    // button5 (prefab fields)
    button5.levelNum = 4;

    // btnPlayLevel (components)
    const btnPlayLevelUIButton = UIButton.getComponent(btnPlayLevel);
    btnPlayLevelUIButton.shouldPulse = true;

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    this.mapHolder = mapHolder;
    this.grid = grid;
    this.holo_building_large_png = holo_building_large_png;
    this.holo_building_medium_png = holo_building_medium_png;
    this.holo_building_small_png = holo_building_small_png;
    this.holo_building_medium_png_1 = holo_building_medium_png_1;
    this.holo_building_medium_png_2 = holo_building_medium_png_2;
    this.holo_building_medium_png_3 = holo_building_medium_png_3;
    this.holo_building_medium_png_4 = holo_building_medium_png_4;
    this.holo_building_medium_png_5 = holo_building_medium_png_5;
    this.holo_building_medium_png_6 = holo_building_medium_png_6;
    this.holo_building_small_png_1 = holo_building_small_png_1;
    this.holo_building_small_png_2 = holo_building_small_png_2;
    this.holo_building_small_png_3 = holo_building_small_png_3;
    this.holo_building_small_png_4 = holo_building_small_png_4;
    this.holo_building_small_png_5 = holo_building_small_png_5;
    this.holo_building_small_png_6 = holo_building_small_png_6;
    this.holo_building_medium_png_7 = holo_building_medium_png_7;
    this.dotHolder = dotHolder;
    this.buttons = buttons;
    this.button1 = button1;
    this.button2 = button2;
    this.button3 = button3;
    this.button4 = button4;
    this.button5 = button5;
    this.heroDisk = heroDisk;
    this.batwheelImage = batwheelImage;
    this.playBox = playBox;
    this.box_bg = box_bg;
    this.btnPlayLevel = btnPlayLevel;
    this.bcHolder = bcHolder;
    this.bcBg = bcBg;
    this.character = character;
    this.btnBack = btnBack;
    this.btnAudio = btnAudio;
    this.levelButtons = levelButtons;
    this.buildings = buildings;
    this.dots = dots;

    this.events.emit("scene-awake");
  }

  private mapHolder!: Phaser.GameObjects.Container;
  private grid!: Phaser.GameObjects.Image;
  private holo_building_large_png!: Phaser.GameObjects.Image;
  private holo_building_medium_png!: Phaser.GameObjects.Image;
  private holo_building_small_png!: Phaser.GameObjects.Image;
  private holo_building_medium_png_1!: Phaser.GameObjects.Image;
  private holo_building_medium_png_2!: Phaser.GameObjects.Image;
  private holo_building_medium_png_3!: Phaser.GameObjects.Image;
  private holo_building_medium_png_4!: Phaser.GameObjects.Image;
  private holo_building_medium_png_5!: Phaser.GameObjects.Image;
  private holo_building_medium_png_6!: Phaser.GameObjects.Image;
  private holo_building_small_png_1!: Phaser.GameObjects.Image;
  private holo_building_small_png_2!: Phaser.GameObjects.Image;
  private holo_building_small_png_3!: Phaser.GameObjects.Image;
  private holo_building_small_png_4!: Phaser.GameObjects.Image;
  private holo_building_small_png_5!: Phaser.GameObjects.Image;
  private holo_building_small_png_6!: Phaser.GameObjects.Image;
  private holo_building_medium_png_7!: Phaser.GameObjects.Image;
  private dotHolder!: Phaser.GameObjects.Container;
  private buttons!: Phaser.GameObjects.Container;
  private button1!: LevelButton;
  private button2!: LevelButton;
  private button3!: LevelButton;
  private button4!: LevelButton;
  private button5!: LevelButton;
  private heroDisk!: Phaser.GameObjects.Image;
  private batwheelImage!: Phaser.GameObjects.Image;
  private playBox!: Phaser.GameObjects.Container;
  private box_bg!: Phaser.GameObjects.Image;
  private btnPlayLevel!: BtnPlayLevel;
  private bcHolder!: Phaser.GameObjects.Container;
  private bcBg!: Phaser.GameObjects.Rectangle;
  private character!: Phaser.GameObjects.Image;
  private btnBack!: BtnBack;
  private btnAudio!: BtnAudio;
  private levelButtons!: LevelButton[];
  private buildings!: Phaser.GameObjects.Image[];
  private dots!: Phaser.GameObjects.Image[];

  /* START-USER-CODE */
  protected sceneData!: SceneData;

  private villains: string[] = ['prank', 'jestah', 'ducky', 'quizz', 'snowy'];
  private heroes: string[] = ['bam', 'bibi', 'redbird', 'batwing', 'buff'];
  private heroCheers: string[] = [
    Sounds.Track.BamCheer1,
    Sounds.Track.BibiCheer1,
    Sounds.Track.RedbirdCheer1,
    Sounds.Track.BatwingCheer1,
    Sounds.Track.BuffCheer1
  ];
  private lines!: Phaser.GameObjects.Line[];
  private unselectColour: number = 0x20e4e2;
  private selectColour: number = 0x12ff00;

  private selectedLevel: number = -1;

  private batComp!: SpineGameObject;
  private batCompContainer!: SpineContainer;

  protected sndAlarmRef: string = '';
  private levelSelected: boolean = false;
  private playButtonTween: Phaser.Tweens.Tween | undefined;
  private playButtonIdleCallback: Phaser.Time.TimerEvent | undefined;

  public init(data: SceneData): void {
    this.sceneData = data;

    super.init(data);
  }

  public create() {
    super.create();
    this.editorCreate();

    this.btnBack.once(UIButton.events.clicked, this.back, this);
    this.btnPlayLevel.once(UIButton.events.clicked, this.showHeroAnimation, this);

    this.selectedLevel = -1;

    this.lines = [];
    let i = 0;
    for (const level of this.levelButtons) {
      level.on(LevelButton.events.LevelSelected, this.onLevelSelected, this);

      level.setIcon('icon-villain-' + this.villains[i]);
      const dot = this.dots[i];
      this.lines[i] = this.add.line(dot.x, dot.y, 0, 0, level.x - this.dots[i].x, level.y - this.dots[i].y, 0xff0000).setOrigin(0);
      this.dotHolder.add(this.lines[i]);
      this.lines[i].scale = 0;
      dot.scale = 0;
      level.scale = 0;
      dot.tint = this.unselectColour;
      this.lines[i].setStrokeStyle(8, this.unselectColour);
      level.tintButton(this.unselectColour);
      i++;
    }

    for (let i = 0; i < this.buildings.length; i++) {
      const building = this.buildings[i];
      building.scale = 0;
      building.alpha = 0.85;
    }
    this.grid.scale = 0;

    this.playBox.scale = 0;
    this.batwheelImage.scale = 0;
    this.btnPlayLevel.scale = 0;

    this.levelSelected = false;

    this.batComp = this.add.spine(0, 0, 'batcomputer');
    this.batComp.preMultipliedAlpha = true;
    this.batCompContainer = this.add.spineContainer(0, 252);
    this.batCompContainer.add(this.batComp);

    this.bcHolder.add(this.batCompContainer);

    this.displayBatComp();

    /* let success;
       [this.sndAlarmRef, success] = app.audioHandler.playSound(this, "SndCompAlarm1", Sounds.Channel.SFX, {
           volume: 1.0,
           loop: true
       });

       this.time.addEvent({ delay: 3800, callback: this.stopAlarm, callbackScope: this });*/
  }

  private displayBatComp() {
    this.batComp.visible = false;
    this.batComp.on('start', (t: spine.TrackEntry) => {
      if (t.animation.name == BatComputerAnimations.LargePopup) {
        this.time.delayedCall(100, () => {
          this.batComp.visible = true;
        });
      }
    });
    this.batComp.setAnimation(0, BatComputerAnimations.LargeStatic, false, true);
    this.time.delayedCall(300, () => {
      app.audioHandler.playSound(this, Sounds.Track.CompOn1, Sounds.Channel.SFX);
    });
    this.time.delayedCall(600, () => {
      this.batComp.setAnimation(0, BatComputerAnimations.LargePopup);
    });

    this.time.delayedCall(1500, () => {
      this.batComp.setAnimation(0, BatComputerAnimations.LargeLaugh);
    });

    this.time.delayedCall(2500, () => {
      app.audioHandler.playSound(this, Sounds.Track.CompOff1, Sounds.Channel.SFX);
      this.add.tween({
        targets: [this.bcHolder],
        scale: 0,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        onComplete: () => {
          this.displayMenu();
        },
        onCompleteScope: this
      });
    });
  }

  private displayMenu() {
    this.displayBuildings();
    this.displayButtons();
    this.displayStars();

    this.playBox.scale = 0;
    this.batwheelImage.scale = 0;
    this.btnPlayLevel.scale = 0;

    this.time.delayedCall(2500, () => {
      if (this.selectedLevel == -1) {
        let lastLevelPlayed = GameDataHandler.getLastLevelPlayed(this);
        let lastLevelNumber: number = 0;

        if (lastLevelPlayed) {
          // LevelNameValues is 1-5 while the index os 0-4 so we don't need to add +1 to get the next level as the value is already 1 higher.
          lastLevelNumber = Number(lastLevelPlayed?.match(/\d+/g)?.[0] ?? 0);
          if (lastLevelNumber >= this.levelButtons.length) lastLevelNumber = 0;
        }

        lastLevelNumber = this.findFreeLevel(lastLevelNumber);
        this.selectLevel(lastLevelNumber);
      }
    });
  }

  protected findFreeLevel(lastLevel: number) {
    let levels = [...this.levelButtons];
    let temp = levels.splice(0, lastLevel);
    levels.push(...temp);

    for (let i = 0; i < levels.length; i++) {
      let stars = levels[i].CollectedStars;
      if (stars == 0) return levels[i].levelNum;
    }

    return lastLevel;
  }

  private displayBuildings() {
    app.audioHandler.playSound(this, Sounds.Track.CompOn2, Sounds.Channel.SFX);

    this.add.tween({
      targets: [this.grid],
      scale: 1,
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 300
    });

    let delay: number = 800;
    for (let i = 0; i < this.buildings.length; i++) {
      const building = this.buildings[i];
      this.add.tween({
        targets: [building],
        scale: 1,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: delay,
        onStart: () => {
          app.audioHandler.playSound(this, Sounds.Track.CompOn2, Sounds.Channel.SFX, { volume: 0.3 });
        },
        onStartScope: this
      });
      delay += 20;
    }
  }

  private displayButtons() {
    let delay: number = 1000;
    let i = 0;

    for (const level of this.levelButtons) {
      this.add.tween({
        targets: [this.dots[i]],
        scale: 1,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: delay,
        onStart: () => {
          app.audioHandler.playSound(this, Sounds.Track.CompOn1, Sounds.Channel.SFX);
        },
        onStartScope: this
      });
      delay += 100;
      this.add.tween({
        targets: [this.lines[i]],
        scale: 1,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: delay
      });
      delay += 100;
      this.add.tween({
        targets: [level],
        scale: level.TargetScale,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: delay
      });
      delay -= 100;

      i++;
    }
  }

  protected displayStars() {
    let delay = 1000;
    for (const [index, level] of this.levelButtons.entries()) {
      if (level.canShowStars()) {
        this.time.delayedCall(delay + index * 100, () => {
          level.activate();
          this.moveLevelLines(this.lines[index], this.levelButtons[index].y - this.dots[index].y + 35 * level.TargetScale + 58);
        });
      } else {
        // this.moveLevelLines(this.lines[index], this.levelButtons[index].y - this.dots[index].y + 62 * (1 / level.TargetScale));
        this.moveLevelLines(this.lines[index], this.levelButtons[index].y - this.dots[index].y + 58);
      }
    }
  }

  protected stopAlarm() {
    if (this.sndAlarmRef != '') {
      app.audioHandler.stopAndRemoveSound(this.sndAlarmRef, Sounds.Channel.SFX);
      this.sndAlarmRef = '';
    }
  }

  public back() {
    this.btnPlayLevel.off(UIButton.events.clicked, this.showHeroAnimation, this);
    app.gotoNextScene(this, TransitionPoint.LevelSelectBack);
  }

  protected onLevelSelected(selectedLevel: LevelButton) {
    // console.log("LEVEL "+selectedLevel.levelNum);
    if (selectedLevel.levelNum != this.selectedLevel) {
      this.selectLevel(selectedLevel.levelNum);
    } else {
      app.audioHandler.playSound(this, Sounds.Track.CompOff1, Sounds.Channel.SFX);
    }
  }

  protected selectLevel(levelNum: number) {
    // console.log("level selected", this.levelSelected);
    if (this.levelSelected) {
      return;
    }

    if (this.levelButtons[levelNum].canShowStars()) {
      this.animateLevelLinesSelected(this.lines[levelNum], this.levelButtons[levelNum].y - this.dots[levelNum].y + (35 * 1.2) + (64 * 1.1));
    } else {
      this.animateLevelLinesSelected(this.lines[levelNum], this.levelButtons[levelNum].y - this.dots[levelNum].y + 58 * 1.1);
    }

    app.audioHandler.playSound(this, Sounds.Track.CompOn2, Sounds.Channel.SFX);
    let firstSelect: boolean = false;
    if (this.selectedLevel >= 0) {
      this.lines[this.selectedLevel].setStrokeStyle(8, this.unselectColour);
      // this.moveLevelLines(this.lines[this.selectedLevel], this.levelButtons[this.selectedLevel].y - this.dots[this.selectedLevel].y);
      this.levelButtons[this.selectedLevel].unselect(this.unselectColour);
      this.dots[this.selectedLevel].tint = this.unselectColour;
    } else {
      firstSelect = true;
    }

    this.selectedLevel = levelNum;

    this.lines[this.selectedLevel].setStrokeStyle(8, this.selectColour);
    // this.moveLevelLines(this.lines[this.selectedLevel], this.levelButtons[this.selectedLevel].y - this.dots[this.selectedLevel].y + 35 + 62);
    this.levelButtons[this.selectedLevel].select(this.selectColour);
    this.dots[this.selectedLevel].tint = this.selectColour;

    this.add.tween({
      targets: [this.dots[this.selectedLevel]],
      scale: 1.3,
      duration: 150,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 0
    });
    this.add.tween({
      targets: [this.dots[this.selectedLevel]],
      scale: 1,
      duration: 150,
      ease: Phaser.Math.Easing.Cubic.In,
      delay: 150
    });

    this.add.tween({
      targets: [this.levelButtons[this.selectedLevel]],
      scale: this.levelButtons[this.selectedLevel].TargetScale * 1.1,
      duration: 100,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 0
    });
    this.add.tween({
      targets: [this.levelButtons[this.selectedLevel]],
      scale: this.levelButtons[this.selectedLevel].TargetScale,
      duration: 100,
      ease: Phaser.Math.Easing.Cubic.In,
      delay: 150
    });

    this.add.tween({
      targets: this.character,
      x: 450,
      y: 1050,
      duration: 300,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 0,
      onComplete: () => {
        this.character.setFrame('popup-' + this.heroes[this.selectedLevel] + '.png');
      }
    });

    let characterPosY = 640;
    if (this.selectedLevel == 0) characterPosY = 680;
    else if (this.selectedLevel == 1) characterPosY = 670;
    this.add.tween({
      targets: this.character,
      x: this.selectedLevel == 3 ? 530 : 600,
      y: characterPosY,
      angle: this.selectedLevel == 3 || this.selectedLevel == 4 ? 0 : 10,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 300
    });

    let playDelay: number = 150;
    if (firstSelect) {
      playDelay = 200;
      this.add.tween({
        targets: [this.playBox],
        scale: 1,
        duration: playDelay,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: 0
      });

      this.btnPlayLevel.pausePulse();
      this.add.tween({
        targets: [this.btnPlayLevel, this.batwheelImage],
        scale: 1,
        duration: 150,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: playDelay,
        onComplete: () => {
          this.btnPlayLevel.resumePulse();
        }
      });
      playDelay += 150;
    } else {
      playDelay = 100;
      this.add.tween({
        targets: [this.batwheelImage],
        scale: 0,
        duration: playDelay,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: 0
      });

      this.btnPlayLevel.pausePulse();
      this.btnPlayLevel.scale = 0.8;
      this.add.tween({
        targets: [this.btnPlayLevel],
        scale: 1,
        duration: 250,
        ease: Phaser.Math.Easing.Cubic.Out,
        delay: 0,
        onComplete: () => {
          this.btnPlayLevel.resumePulse();
        }
      });
    }
  }

  protected moveLevelLines(line: Phaser.GameObjects.Line, offsetY: number) {
    this.add.tween({
      targets: [line.geom],
      y2: offsetY,
      duration: 550,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  protected animateLevelLinesSelected(line: Phaser.GameObjects.Line, offsetY: number) {
    this.add.tween({
      targets: [line.geom],
      y2: offsetY,
      duration: 120,
      ease: Phaser.Math.Easing.Cubic.Out,
      yoyo: true
    });
  }

  protected showHeroAnimation() {
    this.btnBack.off(UIButton.events.clicked, this.back, this);
    this.add.tween({
      targets: this.btnBack,
      alpha: 0,
      duration: 300,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.character,
      x: 450,
      y: 1050,
      duration: 300,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    const startDelay = 450;

    this.add.tween({
      targets: [this.btnPlayLevel],
      alpha: 0,
      scale: 0,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.In
    });

    app.audioHandler.playSound(this, Sounds.Track.CompSwitch1, Sounds.Channel.SFX);
    this.batwheelImage.setFrame('icon-hero-' + this.heroes[this.selectedLevel] + '.png');

    this.heroDisk.scaleX = this.heroDisk.scaleY = 0;
    this.add.tween({
      targets: [this.heroDisk],
      alpha: 1,
      scaleX: 1.2,
      scaleY: 1.2,
      duration: 150,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: startDelay
    });

    this.batwheelImage.alpha = 0;
    this.add.tween({
      targets: [this.batwheelImage],
      alpha: 1,
      scale: 1,
      duration: 150,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: startDelay + 100
    });

    let dot = this.dots[this.selectedLevel];
    let tempMatrix = new Phaser.GameObjects.Components.TransformMatrix();
    let tempParentMatrix = new Phaser.GameObjects.Components.TransformMatrix();
    dot.getWorldTransformMatrix(tempMatrix, tempParentMatrix);
    let dotGlobal: DecomposedMatrix = tempMatrix.decomposeMatrix() as DecomposedMatrix;
    // let localVector = this.batwheelImage.getLocalPoint(dotGlobal.translateX, dotGlobal.translateY);

    this.add.tween({
      targets: [this.heroDisk],
      x: dotGlobal.translateX,
      y: dotGlobal.translateY,
      scaleX: 0.5,
      scaleY: 0.5,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: startDelay + 700
    });

    this.add.tween({
      targets: [this.batwheelImage],
      x: dotGlobal.translateX,
      y: dotGlobal.translateY,
      scaleX: 0.4,
      scaleY: 0.4,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: startDelay + 700
    });

    this.time.delayedCall(500, () => {
      app.audioHandler.playSound(this, this.heroCheers[this.selectedLevel], Sounds.Channel.SFX);
    });

    this.levelSelected = true;
    this.time.delayedCall(startDelay + 1700, this.playLevel, undefined, this);
  }

  protected playLevel() {
    if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
    let selectedLevel = ('level' + (this.selectedLevel + 1)) as LevelNameValues;
    this.sceneData.runSettings.selectedLevel = selectedLevel;
    GameDataHandler.updateLastLevelPlayed(this, selectedLevel);
    app.gotoNextScene(this, TransitionPoint.LevelSelectEnd, this.sceneData);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

export enum BatComputerAnimations {
  LargeBlink = 'large_blink',
  LargeLaugh = 'large_laugh',
  LargePopup = 'large_pop_up',
  LargeStatic = 'large_static',
  Shrink = 'shrink',
  SmallBlink = 'small_blink',
  SmallLaugh = 'small_laugh',
  SmallSmile = 'small_smile',
  SmallStatic = 'small_static'
}

interface DecomposedMatrix {
  rotation: number;
  scaleX: number;
  scaleY: number;
  translateX: number;
  translateY: number;
}
